import React, { useState } from 'react';

const services = [
  'Web Development','Mobile App Development','UI/UX Design',
  'Digital Marketing','E-Commerce','Cloud & DevOps','AI & Automation','Other',
];

export default function Contact() {
  const [form, setForm] = useState({ name:'', email:'', phone:'', service:'', message:'' });
  const [sent, setSent] = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = e => {
    e.preventDefault();
    // Replace with your actual form submission endpoint
    setSent(true);
  };

  return (
    <main className="vt-page">

      {/* Hero */}
      <section className="vt-page-hero vt-page-hero--contact">
        <div className="vt-page-hero__overlay" />
        <div className="vt-container vt-page-hero__content">
          <span className="vt-page-hero__eyebrow">Contact Us</span>
          <h1 className="vt-page-hero__title">Let's Build Something Together</h1>
          <p className="vt-page-hero__sub">Get a free consultation and project quote within 24 hours.</p>
        </div>
      </section>

      <section className="vt-section">
        <div className="vt-container">
          <div className="vt-contact-grid">

            {/* Left: Info */}
            <div className="vt-contact-info">
              <h2>Get In Touch</h2>
              <p className="vt-contact-info__sub">We would love to hear about your project. Fill in the form and our team will get back to you within 24 hours.</p>

              <div className="vt-contact-cards">
                <div className="vt-contact-card">
                  <div className="vt-contact-card__icon">📍</div>
                  <div>
                    <strong>Our Office</strong>
                    <p>E-106 Akshardham Heights, S.P. Ring Road, Vastral Road, Ahmedabad, Gujarat 382418</p>
                  </div>
                </div>
                <div className="vt-contact-card">
                  <div className="vt-contact-card__icon">📧</div>
                  <div>
                    <strong>Email Us</strong>
                    <p><a href="mailto:vedanskrix@gmail.com">vedanskrix@gmail.com</a></p>
                  </div>
                </div>
                <div className="vt-contact-card">
                  <div className="vt-contact-card__icon">💬</div>
                  <div>
                    <strong>WhatsApp</strong>
                    <p><a href="https://wa.me/918758637022" target="_blank" rel="noreferrer">+91 8758637022</a></p>
                  </div>
                </div>
                <div className="vt-contact-card">
                  <div className="vt-contact-card__icon">🕐</div>
                  <div>
                    <strong>Office Hours</strong>
                    <p>Mon – Sat: 9:00 AM – 7:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Form */}
            <div className="vt-contact-form-wrap">
              {sent ? (
                <div className="vt-contact-success">
                  <div className="vt-contact-success__icon">✅</div>
                  <h3>Message Sent!</h3>
                  <p>Thank you for reaching out. We will contact you within 24 hours.</p>
                </div>
              ) : (
                <form className="vt-contact-form" onSubmit={submit}>
                  <h3 className="vt-contact-form__title">Send Us a Message</h3>

                  <div className="vt-form-row">
                    <div className="vt-form-group">
                      <label htmlFor="name">Full Name *</label>
                      <input id="name" name="name" type="text" required placeholder="Your full name" value={form.name} onChange={handle} />
                    </div>
                    <div className="vt-form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input id="email" name="email" type="email" required placeholder="your@email.com" value={form.email} onChange={handle} />
                    </div>
                  </div>

                  <div className="vt-form-row">
                    <div className="vt-form-group">
                      <label htmlFor="phone">Phone Number</label>
                      <input id="phone" name="phone" type="tel" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={handle} />
                    </div>
                    <div className="vt-form-group">
                      <label htmlFor="service">Service Needed</label>
                      <select id="service" name="service" value={form.service} onChange={handle}>
                        <option value="">Select a service</option>
                        {services.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                  </div>

                  <div className="vt-form-group">
                    <label htmlFor="message">Your Message *</label>
                    <textarea id="message" name="message" required rows={5} placeholder="Tell us about your project..." value={form.message} onChange={handle} />
                  </div>

                  <button type="submit" className="vt-contact-form__btn">Send Message →</button>
                </form>
              )}
            </div>

          </div>
        </div>
      </section>
    </main>
  );
}
